import { useState, useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { useSelector } from "react-redux"

import { showLoading } from 'services/util'

import { urlQueryParser } from 'services/util'
import { getPublicAuctionDetail } from '../api'
import CustomMarkdown from 'sites/auctions/components/CustomMarkdown'
import { getImageUrl } from '../util/images'
import { getAuctionUser } from '../redux/selectors'
import { getLoggedInUser } from 'redux/selectors'

import ItemInfoBox from './ItemInfoBox'

import css from './sass/itempage.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import ItemBrowseSignUp from './ItemBrowseSignUp'
import { getPrivateItemRoute, isUserRegisteredForAuction, useResolvedAuctionUser } from './utils'

export default function Item(props) {  
  const [itemData, setItemData] = useState()
  const [imageUrl, setImageUrl] = useState()

  const [auctionDetail, setAuctionDetail] = useState()
  const authenticatedUser = useSelector(getLoggedInUser)
  const auctionUser = useSelector(getAuctionUser)

  const { auctionId: auctionCode, itemId: queryItemCode } = urlQueryParser(props.location.search)
  const userAttendingAuction = isUserRegisteredForAuction(auctionUser, auctionCode)
  const hasResolvedAuctionUser = useResolvedAuctionUser(authenticatedUser, auctionUser)
  const privateItemRoute = itemData
    ? getPrivateItemRoute(auctionCode, itemData.ItemCode, Boolean(itemData.FixedItemId))
    : undefined

  // load auction data by code, so it will work for deep-linking
  useEffect(() => {
    if (!auctionCode)
      return

    showLoading(true)

    const getDetails = async () => {
      const {success, error} = await getPublicAuctionDetail(auctionCode)
      showLoading(false)

      if (error || !success || !success.auction || success.auction.error) {
        console.log('Error!', error ||  success?.auction?.error || "No auction found")
      }
      else if (success.auction) {
        setAuctionDetail(success.auction)
      }
    }

    getDetails()

  }, [auctionCode])
  

  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auctionDetail?.AuctionCode, itemData?.ItemCode, itemData?.ImageFilename)
    setImageUrl(url)

    if (itemData?.FixedItemId) {
      localStorage.setItem('savedFixedItemId', itemData.FixedItemId)
      localStorage.removeItem('savedItemId')
    }
    if (itemData?.ItemId) {
      localStorage.setItem('savedItemId', itemData.ItemId)
      localStorage.removeItem('savedFixedItemId')
    }

  }, [auctionDetail, itemData])

  useEffect(() => {
    if (!auctionDetail) return

    const allItems = []
    if (auctionDetail?.Items?.length > 0) allItems.push(...auctionDetail.Items)
    if (auctionDetail?.FixedItems?.length > 0) allItems.push(...auctionDetail.FixedItems)

    setItemData(allItems.find(item => item.ItemCode === queryItemCode))
  }, [auctionDetail, queryItemCode])


  if (authenticatedUser && hasResolvedAuctionUser && userAttendingAuction && privateItemRoute) {
    return <Redirect to={privateItemRoute} />
  }
  if (authenticatedUser && !hasResolvedAuctionUser) return (<></>)
  if (!itemData) return (<></>)

  return (
    <>
      <div className={css['item-page-path']}>
        <Link className={`${css['path-text']} ${themeCss['bold-nodecoration']}`} to={{ pathname: '/flow/auction', search: `?auctionId=${auctionDetail.AuctionCode}` }}> {auctionDetail.Title} </Link>
        <p className={css['path-dash']}> / </p>
        <p className={css['path-text']}>{itemData.Title} </p>
      </div>
      <div className={`${css['item-container']} ${themeCss['blue-background']}`}>
        <img className={css['item-page-img']} src={imageUrl} alt={itemData.Title} />
        <div className={css['item-bottom-info']}>
          <ItemBrowseSignUp auctionDetail={auctionDetail} />
          <CustomMarkdown text={itemData.Description} cssClass={css['item-description']} />
          <ItemInfoBox item={itemData} />
        </div>
      </div>
    </>
  ) 
}
